import constructMetaObject from './constructMetaObject'
import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformService (data) {
	return applyToOneOrMany(_transformService, data)
}

function _transformService (post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch'


	if (post.polylang.translations) {
		const firstAlternateLanguage = Object.keys(post.polylang.translations)[0]
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		}
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		}
	}

	post.iconInverted = post.service_icon_inverted.sizes.bandara_medium
	post.icon = post.service_icon.sizes.bandara_medium

	// post.featuredImageUrl = post.featured_image ? post.featured_image.sizes.bandara_medium : ''
	// post.featuredImageAlt = post.featured_image && post.featured_image.alt ? post.featured_image.alt : 'Featured Image'

	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformService.js